var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    [
      _c(
        "v-card",
        { attrs: { elevation: "0" } },
        [
          _c(
            "v-card-title",
            { staticClass: "mb-4 px-0" },
            [
              _c(
                "v-btn",
                {
                  attrs: {
                    color: _vm.showAddForm ? "" : "primary",
                    elevation: "0",
                    "prepend-icon": _vm.showAddForm ? "mdi-close" : "mdi-plus",
                  },
                  on: { click: _vm.toggleForm },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.showAddForm ? "Отменить" : "Добавить схему") +
                      " "
                  ),
                ]
              ),
              _vm.schemes.length >= 2
                ? _c(
                    "v-alert",
                    {
                      staticClass: "ml-4 mb-0",
                      attrs: {
                        type: "info",
                        dense: "",
                        text: "",
                        size: "small",
                      },
                    },
                    [
                      _vm._v(
                        " Схемы, которые в списке выше перекрывают действие нижних "
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c("v-expand-transition", [
            _vm.showAddForm
              ? _c(
                  "div",
                  [
                    _c(
                      "v-card",
                      {
                        staticClass: "pa-6 mb-6",
                        attrs: { variant: "outlined" },
                      },
                      [
                        _c("h2", { staticClass: "text-h6 mb-4" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.editingSchemeId
                                  ? "Редактировать схему"
                                  : "Новая схема адаптации"
                              ) +
                              " "
                          ),
                        ]),
                        _c(
                          "div",
                          [
                            _c(
                              "v-row",
                              [
                                _c(
                                  "v-col",
                                  { attrs: { cols: "12", md: "3" } },
                                  [
                                    _c("v-label", { staticClass: "mb-2" }, [
                                      _vm._v("Временной период"),
                                    ]),
                                    _c("v-select", {
                                      attrs: {
                                        items: [
                                          { value: "all", text: "Весь период" },
                                          {
                                            value: "custom",
                                            text: "Пользовательский период",
                                          },
                                        ],
                                        variant: "outlined",
                                        "hide-details": "",
                                      },
                                      model: {
                                        value: _vm.newScheme.periodFilterType,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.newScheme,
                                            "periodFilterType",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "newScheme.periodFilterType",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm.newScheme.periodFilterType === "custom"
                                  ? [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12", md: "3" } },
                                        [
                                          _c(
                                            "v-label",
                                            { staticClass: "mb-2" },
                                            [_vm._v("Начало периода")]
                                          ),
                                          _c("v-text-field", {
                                            attrs: {
                                              items: _vm.timePoints,
                                              placeholder: "Начало",
                                              variant: "outlined",
                                              hint:
                                                "От 0 до " +
                                                _vm.timePoints[
                                                  _vm.timePoints.length - 1
                                                ],
                                              min: 0,
                                              max: _vm.timePoints[
                                                _vm.timePoints.length - 1
                                              ],
                                              clearable: "",
                                            },
                                            model: {
                                              value: _vm.newScheme.startDay,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.newScheme,
                                                  "startDay",
                                                  _vm._n($$v)
                                                )
                                              },
                                              expression: "newScheme.startDay",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12", md: "3" } },
                                        [
                                          _c(
                                            "v-label",
                                            { staticClass: "mb-2" },
                                            [_vm._v("Конец периода")]
                                          ),
                                          _c("v-text-field", {
                                            attrs: {
                                              items: _vm.timePoints,
                                              placeholder: "Конец",
                                              variant: "outlined",
                                              hint:
                                                "От " +
                                                _vm.newScheme.startDay +
                                                " до " +
                                                _vm.timePoints[
                                                  _vm.timePoints.length - 1
                                                ],
                                              min: _vm.newScheme.startDay,
                                              max: _vm.timePoints[
                                                _vm.timePoints.length - 1
                                              ],
                                              clearable: "",
                                            },
                                            model: {
                                              value: _vm.newScheme.endDay,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.newScheme,
                                                  "endDay",
                                                  _vm._n($$v)
                                                )
                                              },
                                              expression: "newScheme.endDay",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  : _vm._e(),
                              ],
                              2
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "mt-2 text-caption text-grey",
                                class: {
                                  "text-grey":
                                    _vm.selectedTimePoints.length > 0,
                                  "text-error":
                                    _vm.selectedTimePoints.length === 0,
                                },
                              },
                              [
                                _vm._v(
                                  " Выбрано временных точек: " +
                                    _vm._s(_vm.selectedTimePoints.length) +
                                    " из " +
                                    _vm._s(_vm.timePoints.length) +
                                    " "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          [
                            _c(
                              "v-row",
                              { staticClass: "mt-4" },
                              [
                                _c(
                                  "v-col",
                                  { attrs: { cols: "12", md: "3" } },
                                  [
                                    _c("v-label", { staticClass: "mb-2" }, [
                                      _vm._v("Скважины"),
                                    ]),
                                    _c("v-select", {
                                      attrs: {
                                        items: [
                                          {
                                            value: "all",
                                            text: "Все скважины",
                                          },
                                          {
                                            value: "selected",
                                            text: "Выбранные скважины",
                                          },
                                        ],
                                        "hide-details": "",
                                      },
                                      model: {
                                        value: _vm.newScheme.wellFilterType,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.newScheme,
                                            "wellFilterType",
                                            $$v
                                          )
                                        },
                                        expression: "newScheme.wellFilterType",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-expand-transition",
                                  [
                                    _vm.newScheme.wellFilterType === "selected"
                                      ? _c(
                                          "v-col",
                                          { attrs: { cols: "12", md: "6" } },
                                          [
                                            _c(
                                              "v-label",
                                              { staticClass: "mb-2" },
                                              [_vm._v(" ")]
                                            ),
                                            _c("v-select", {
                                              attrs: {
                                                items: _vm.wells,
                                                label: "Выберите скважины",
                                                "item-value": "id",
                                                "item-text": "name",
                                                "hide-details": "",
                                                multiple: "",
                                                chips: "",
                                                "closeable-chips": "",
                                              },
                                              model: {
                                                value:
                                                  _vm.newScheme.selectedWells,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.newScheme,
                                                    "selectedWells",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "newScheme.selectedWells",
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "mt-2 text-caption text-grey",
                                class: {
                                  "text-grey": _vm.selectedWells.length > 0,
                                  "text-error": _vm.selectedWells.length === 0,
                                },
                              },
                              [
                                _vm._v(
                                  " Выбрано скважин: " +
                                    _vm._s(_vm.selectedWells.length) +
                                    " из " +
                                    _vm._s(_vm.wells.length) +
                                    " "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "mt-4" },
                          [
                            _c("v-label", { staticClass: "mb-2" }, [
                              _vm._v("Фильтр по истории"),
                            ]),
                            _c(
                              "v-row",
                              _vm._l(
                                ["production", "debit", "bhp"],
                                function (param) {
                                  return _c(
                                    "v-col",
                                    {
                                      key: param,
                                      attrs: { cols: "12", sm: "6", md: "3" },
                                    },
                                    [
                                      _c(
                                        "label",
                                        { staticClass: "text-caption" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.getParamLabel(
                                                param.toLowerCase()
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "d-flex ga-2" },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              type: "number",
                                              placeholder: "от",
                                              variant: "outlined",
                                              dense: "",
                                              hint: "Включительно",
                                              "preserve-hint": "",
                                            },
                                            model: {
                                              value:
                                                _vm.filterInput[param + "Min"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.filterInput,
                                                  param + "Min",
                                                  _vm._n($$v)
                                                )
                                              },
                                              expression:
                                                "filterInput[param + 'Min']",
                                            },
                                          }),
                                          _c("v-text-field", {
                                            attrs: {
                                              type: "number",
                                              placeholder: "до",
                                              variant: "outlined",
                                              dense: "",
                                              hint: "Включительно",
                                              "preserve-hint": "",
                                            },
                                            model: {
                                              value:
                                                _vm.filterInput[param + "Max"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.filterInput,
                                                  param + "Max",
                                                  _vm._n($$v)
                                                )
                                              },
                                              expression:
                                                "filterInput[param + 'Max']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  )
                                }
                              ),
                              1
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "mt-2 text-caption text-grey",
                                class: {
                                  "text-grey": _vm.newFilteredWells.length > 0,
                                  "text-error":
                                    _vm.newFilteredWells.length === 0,
                                },
                              },
                              [
                                _vm._v(
                                  " Подходит под условия: " +
                                    _vm._s(_vm.newFilteredWells.length) +
                                    " из " +
                                    _vm._s(_vm.wells.length) +
                                    " "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {},
                          [
                            _c(
                              "v-row",
                              { staticClass: "mt-4" },
                              _vm._l(
                                _vm.newScheme.adaptationParams,
                                function (enabled, param) {
                                  return _c(
                                    "v-col",
                                    { key: param, attrs: { cols: "12" } },
                                    [
                                      _c("v-switch", {
                                        staticClass: "pa-0 ma-0",
                                        attrs: {
                                          label: _vm.getAdaptationLabel(param),
                                          "hide-details": "",
                                        },
                                        model: {
                                          value:
                                            _vm.newScheme.adaptationParams[
                                              param
                                            ],
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.newScheme.adaptationParams,
                                              param,
                                              $$v
                                            )
                                          },
                                          expression:
                                            "newScheme.adaptationParams[param]",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                }
                              ),
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "d-flex ga-4 mt-6" },
                          [
                            _c("v-spacer"),
                            _c(
                              "v-btn",
                              {
                                staticClass: "mr-4",
                                attrs: {
                                  "prepend-icon": "mdi-content-save",
                                  color: "primary",
                                },
                                on: { click: _vm.handleAddScheme },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.editingSchemeId
                                        ? "Сохранить изменения"
                                        : "Добавить схему"
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  "prepend-icon": "mdi-close",
                                  elevation: "0",
                                  variant: "text",
                                },
                                on: { click: _vm.resetForm },
                              },
                              [_vm._v(" Отменить ")]
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]),
          _c(
            "div",
            [
              _vm.schemes.length === 0
                ? _c("v-alert", { attrs: { type: "info", outlined: "" } }, [
                    _vm._v(
                      ' Нет добавленных схем. Нажмите "Добавить схему" для начала. '
                    ),
                  ])
                : _vm._e(),
              _c(
                "draggable",
                {
                  model: {
                    value: _vm.schemes,
                    callback: function ($$v) {
                      _vm.schemes = $$v
                    },
                    expression: "schemes",
                  },
                },
                _vm._l(_vm.schemes, function (scheme, index) {
                  return _c(
                    "v-card",
                    { key: scheme.id, staticClass: "mb-3" },
                    [
                      _c("v-card-text", { staticClass: "px-6" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex justify-space-between align-start",
                          },
                          [
                            _c("div", { staticClass: "flex-grow-1" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex flex-wrap align-center ga-4 mb-2",
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "font-weight-bold" },
                                    [
                                      _vm._v(
                                        "#" + _vm._s(_vm.schemes.length - index)
                                      ),
                                    ]
                                  ),
                                  _c("v-chip", { attrs: { size: "small" } }, [
                                    _vm._v(
                                      _vm._s(_vm.getPeriodDisplay(scheme))
                                    ),
                                  ]),
                                  _c("v-chip", { attrs: { size: "small" } }, [
                                    _vm._v(_vm._s(_vm.getWellsDisplay(scheme))),
                                  ]),
                                ],
                                1
                              ),
                              _c("p", { staticClass: "body-2" }, [
                                _c(
                                  "span",
                                  { staticClass: "font-weight-medium" },
                                  [_vm._v("Адаптация:")]
                                ),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.getAdaptationDisplay(
                                        scheme.adaptationParams
                                      )
                                    ) +
                                    " "
                                ),
                              ]),
                              _vm.hasFilter(scheme)
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "text-caption text-grey mt-1",
                                    },
                                    [
                                      _vm._v(
                                        " Фильтр: " +
                                          _vm._s(
                                            _vm.getFilterDisplay(
                                              scheme.filterParams
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]),
                            _c(
                              "div",
                              { staticClass: "d-flex ga-1" },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      icon: "",
                                      size: "small",
                                      color: "primary",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleEditScheme(scheme)
                                      },
                                    },
                                  },
                                  [_c("v-icon", [_vm._v("mdi-pencil")])],
                                  1
                                ),
                                _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      icon: "",
                                      size: "small",
                                      color: "error",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleDeleteScheme(scheme.id)
                                      },
                                    },
                                  },
                                  [_c("v-icon", [_vm._v("mdi-delete")])],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                      ]),
                    ],
                    1
                  )
                }),
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }